import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Http } from "@angular/http";
import { iConfiguracion, iAPIS } from "../models/basePage";

/**
 * Servicio base para la carga de datos desde distintas APIs
 */
export class BaseService {
  static $inject = ["$http", "configuraciones"];

  public _configuraciones: iConfiguracion;

  constructor(public http: HttpClient, public http2: Http) {
    http2
      .get("./assets/data/datos.json")
      .toPromise()
      .then((resultado: any) => {
        this._configuraciones = <iConfiguracion>resultado.json();
      });
  }

  // #region Métodos del servicio

  /**
   * Construye la dirección base de la API a la que se llamará para procesar datos. Si
   *
   * Comprueba si no se tiene valor, para utilizar la dirección de la primera de las APIS de la lista de configuración
   * @param urlBase Url de referencia
   */
  public DireccionBase(urlBase: string): string {
    return urlBase != undefined && urlBase.trim().length > 0
      ? urlBase
      : this._configuraciones.api.urlAPIs[0].urlApi;
  }

  public GetHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    return headers;
  }

  private IncluirFederacion(ruta: string): string {
    if (
      this._configuraciones.federacion != undefined &&
      this._configuraciones.federacion > 0
    ) {
      if (ruta.indexOf("?") > 0) {
        ruta += "&federacion=" + this._configuraciones.federacion;
      } else {
        ruta += "?federacion=" + this._configuraciones.federacion;
      }
    }
    return ruta;
  }

  /**
   * Obtiene los datos de un método desde varias APIs
   * @param ruta      Método y sus parámetros al que se está llamando
   * @param contador  Contador del número de APIs
   * @param datos     Lista de datos obtenidos hasta el momento
   */
  public GetMultiplesApis(
    ruta: string,
    contador: number = 0,
    datos: any = undefined
  ): Promise<any> {
    // Inclusión de la federación en la petición
    ruta = this.IncluirFederacion(ruta);

    if (contador >= this._configuraciones.api.urlAPIs.length) {
      return datos;
    } else {
      return this.http
        .get(this._configuraciones.api.urlAPIs[contador].urlApi + ruta, {
          headers: this.GetHeaders(),
        })
        .toPromise()
        .then((response: any) => {
          if (datos == undefined) {
            datos = [];
          }

          if (response instanceof Array) {
            let arrayAny: any[] = <any[]>response;

            arrayAny = arrayAny.map((m) => {
              m.urlApi = this._configuraciones.api.urlAPIs[contador].urlApi;
              m.urlNombre =
                this._configuraciones.api.urlAPIs[contador].urlNombre;
              return m;
            });

            datos = datos.concat(arrayAny);
          } else if (typeof response === "boolean") {
            return response;
          } else {
            response.urlApi =
              this._configuraciones.api.urlAPIs[contador].urlApi;
            response.urlNombre =
              this._configuraciones.api.urlAPIs[contador].urlNombre;
            //datos.push(response);
            return response;
          }

          return this.GetMultiplesApis(ruta, (contador += 1), datos);
        })
        .catch((error) => console.error(error));
    }
  }

  /**
   * Obtiene los datos de un método de la primera API de la lista de disponibles
   * @param urlBase   Url de la api que se utilizará para la solicitud GET
   * @param ruta  Ruta del método para el que se quiere obtener los datos
   */
  public GetUniqueApi(urlBase: string, ruta: string): Promise<any> {
    let _urlBase: string = this.DireccionBase(urlBase);

    ruta = this.IncluirFederacion(ruta);

    return this.http
      .get(_urlBase + ruta, {
        headers: this.GetHeaders(),
      })
      .toPromise()
      .then((response: any) => {
        if (response == null) {
          return null;
        } else if (response instanceof Array) {
          let arrayAny: any[] = <any[]>response;
          let arrayUrlBase: iAPIS[] = this._configuraciones.api.urlAPIs;

          arrayAny = arrayAny.map((m) => {
            m.urlApi = urlBase;
            m.urlNombre = arrayUrlBase.filter(
              (m) => m.urlApi == urlBase
            )[0].urlNombre;
            return m;
          });
          return arrayAny;
        } else if (typeof response === "boolean") {
          return response;
        } else {
          response.urlApi = this._configuraciones.api.urlAPIs[0].urlApi;
          return response;
        }
      })
      .catch((error) => console.error(error));
  }

  /**
   *
   * @param urlBase Url de la API que se utiliza para la solicitud GET
   * @param ruta Ruta del método al que se llama en la API.
   */
  public GetListElements(urlBase: string, ruta: string): Promise<any> {
    let _urlBase: string = this.DireccionBase(urlBase);

    ruta = this.IncluirFederacion(ruta);

    return this.http
      .get(_urlBase + ruta, {
        headers: this.GetHeaders(),
      })
      .toPromise()
      .then((resultado: any) => {
        return resultado;
      })
      .catch((error) => console.error(error));
  }

  /**
   * Envía por POST una consulta. Si los datos vienen con la urlAPI, se envía por esa dirección, si no, se envía por la primera API
   * @param datos     Datos a enviar a la API
   * @param ruta      Ruta del método con los parámetros
   * @param urlBase   Ruta con la URL base de la API
   */
  public Post(
    datos: any,
    ruta: string,
    urlBase: string = undefined
  ): Promise<any> {
    let urlA: string = urlBase;

    if (urlBase == undefined) {
      urlA =
        datos.urlApi != null
          ? datos.urlApi
          : this._configuraciones.api.urlAPIs[0].urlApi;
    }

    let urlNombre = this._configuraciones.api.urlAPIs.filter(
      (m) => m.urlApi == urlA
    )[0].urlNombre;

    ruta = this.IncluirFederacion(ruta);

    return this.http
      .post(urlA + ruta, datos, {
        headers: this.GetHeaders(),
      })
      .toPromise()
      .then((response: any) => {
        if (response instanceof Array) {
          let arrayAny: any[] = <any[]>response;

          arrayAny = arrayAny.map((m) => {
            m.urlApi = urlA;
            m.urlNombre = urlNombre;
            return m;
          });

          return arrayAny;
        } else if (typeof response === "boolean") {
          return response;
        } else {
          response.urlApi = urlA;
          response.urlNombre = urlNombre;
          return response;
        }
      })
      .catch((error) => console.error(error));
  }

  /**
   * Envía por PUT una consulta. Si los datos vienen con la urlAPI, se envía por esa dirección, si no, se envía por la primera API
   * @param datos     Datos a enviar a la API
   * @param ruta      Ruta del método con los parámetros
   * @param urlBase   Ruta con la URL base de la API
   */
  public Put(
    datos: any,
    ruta: string,
    urlBase: string = undefined
  ): Promise<any> {
    let urlA: string = urlBase;

    if (urlBase == undefined) {
      urlA =
        datos.urlApi != null
          ? datos.urlApi
          : this._configuraciones.api.urlAPIs[0].urlApi;
    }

    let urlNombre = this._configuraciones.api.urlAPIs.filter(
      (m) => m.urlApi == urlA
    )[0].urlNombre;

    ruta = this.IncluirFederacion(ruta);

    return this.http
      .put(urlA + ruta, datos, {
        headers: this.GetHeaders(),
      })
      .toPromise()
      .then((response: any) => {
        if (response instanceof Array) {
          let arrayAny: any[] = <any[]>response;

          arrayAny = arrayAny.map((m) => {
            m.urlApi = urlA;
            m.urlNombre = urlNombre;
            return m;
          });

          return arrayAny;
        } else if (typeof response === "boolean") {
          return response;
        } else {
          response.urlApi = urlA;
          response.urlNombre = urlNombre;
          return response;
        }
      })
      .catch((error) => console.error(error));
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/services/baseService.ts